import type { IServiceProvider } from '../../components/interfaces/serviceProvider';
import type { ThunkState } from '../utils/thunkState';
import type { IServiceProviderPayload, ServiceProviderActionType } from './serviceProviderActions';
import { createReducers } from '../utils/createReducers';
import { ReduxStatus } from '../utils/reduxStatus';

const initialState: ThunkState<IServiceProviderPayload> = {
    status: ReduxStatus.INIT,
    data: {
        authorization: {},
        serviceProviders: [],
    },
};

export const serviceProviderReducer = createReducers<ThunkState<IServiceProviderPayload>, ServiceProviderActionType>(
    initialState,
    {
        ERROR_SERVICE_PROVIDERS: (state, action) => {
            return {
                status: ReduxStatus.ERROR,
                data: {
                    authorization: {},
                    serviceProviders: [],
                },
            };
        },
        FETCH_SERVICE_PROVIDERS: (state, action) => {
            return {
                status: ReduxStatus.LOADING,
                data: {
                    authorization: {},
                    serviceProviders: [],
                },
            };
        },
        GET_SERVICE_PROVIDERS: (state, action) => {
            return {
                status: ReduxStatus.DONE,
                data: {
                    serviceProviders: action.payload.serviceProviders,
                    authorization: {
                        ...state.data.authorization,
                        canUpdate: serviceProviderCanUpdateAny(action.payload.serviceProviders),
                    },
                },
            };
        },
    }
);

function serviceProviderCanUpdateAny(serviceProviders: IServiceProvider[]) {
    return serviceProviders.filter((serviceProvider) => serviceProvider.authorization.canUpdate).length > 0;
}
